<template>
  <v-card
    style="padding: 20px;"
  >
    <small>Activity Barceló 01 OCULTAR menú:</small>
    <v-row v-if="allTasks">
      <v-col
        cols="12"
        sm="12"
        md="6"
        lg="6"
        v-for="item of allTasks"
        :key="item.id"
      >
        
        <v-checkbox
          v-model="editedItem"
          :label="item.name"
          :value="item.id"
          multiple
          hide-details
          @change="handleChange"
        />
      </v-col>
      <v-col
        cols="12"
        sm="12"
      >
        
        <v-checkbox
          v-model="allowCustom"
          label="Permitir eventos personalizados [TODAS LAS CATEGORIAS]"
          hide-details
          @change="handleChangeAllowCustom"
        />
      </v-col>
    </v-row>
    <small style="color: #CCCCCC;">
      [NOTA] requiere cerrar sesi&oacute;n
    </small>
    <v-autocomplete
      v-if="allTasks"
      v-model="allowPaxCount"
      :items="allTasks"
      itemText="name"
      itemValue="id"
      multiple
      label="Permitir añadir asistentes"
      @input="handleChangeAllowPaxCount"
    />
  </v-card>
</template>
<script>
export default {
  props: {
    value: {
      type: String,
      required: false,
    },
    onChange: {
      type: Function,
      required: true,
    },
    allowCustomEvents: {
      type: Boolean,
      default: false,
    },
    onChangeAllowCustomEvents: {
      type: Function,
      required: true,
    },
    allowPaxValue: {
      type: Array,
      default: null,
    },
    onChangeAllowPaxCount: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    allowCustom: false,
    editedItem: [],
    allTasks: null,
    allowPaxCount: null,
  }),
  watch: {
    value () {
      this.prepareData()
    },
  },
  mounted () {
    this.prepareData()
    this.handleGetAllTask()
  },
  methods: {
    prepareData () {
      if (this.value !== JSON.stringify(this.editedItem))
        this.editedItem = this.value ? JSON.parse(this.value) : []
      
      this.allowPaxCount = this.allowPaxValue

      this.allowCustom = this.allowCustomEvents ? true : false
    },
    handleGetAllTask () {
      this.allTasks = [
        {
          id: 'we',
          name: 'we'
        },
        {
          id: 'live-stage',
          name: 'live stage'
        },
        {
          id: 'barcy-club',
          name: 'barcy-club'
        },
        {
          id: 'max',
          name: 'max'
        },
        {
          id: 'one',
          name: 'one'
        },
        {
          id: 'pro',
          name: 'pro'
        },
      ]
    },
    handleChange () {
      this.onChange(JSON.stringify(this.editedItem))
    },
    handleChangeAllowCustom () {
      this.onChangeAllowCustomEvents(this.allowCustom)
    },
    handleChangeAllowPaxCount () {
      this.onChangeAllowPaxCount(this.allowPaxCount)
    },
  },
}
</script>
